import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g stroke="red" strokeLinecap="round">
      <path d="M.643 3.21h10.714" />
      <path
        d="M9.849 3.21H2.147c-.124 2.248-.122 4.478.213 6.712a1.685 1.685 0 0 0 1.666 1.435H7.97c.834 0 1.543-.61 1.666-1.435.335-2.234.337-4.464.213-6.712Z"
        fill="#fff"
        strokeLinejoin="round"
      />
      <path
        d="M3.859 3.21v-.428a2.14 2.14 0 1 1 4.279 0v.428M4.714 5.502v3.547M7.282 5.502v3.547"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const DeleteTrashCanIcon = memo(ForwardRef);
export default DeleteTrashCanIcon;
